import { render, staticRenderFns } from "./MatchingProcessItems.vue?vue&type=template&id=2a6ee95d&scoped=true"
import script from "./MatchingProcessItems.vue?vue&type=script&lang=js"
export * from "./MatchingProcessItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ee95d",
  null
  
)

export default component.exports